import axios from 'axios';
import authHeader from '../auth-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getRiwayatPesertaSertifikasi = 'riwayat-peserta/sertifikasi';
const getRiwayatPesertaRpl = 'riwayat-peserta/rpl';

const getDetailRiwayatPesertaSertifikasi = 'riwayat-peserta/sertifikasi/detail'
const getDetailRiwayatPesertaRpl = 'riwayat-peserta/rpl/detail'
const postRiwayatPesertaRplUrl = 'riwayat-peserta/rpl/tambah-rpl-peserta';

class RiwayatPesertaService {

    getDetailRiwayatPesertaSertifikasi(currentPage,pageSize,filter,idUser) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            idUser : idUser
        };
        
        return axios.get(
            API_URL + getDetailRiwayatPesertaSertifikasi ,
        {
            params : data,
            headers: authHeader()
        });
    }

    getDetailRiwayatPesertaRpl(currentPage,pageSize,filter,idUser) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            idUser : idUser
        };
        
        return axios.get(
            API_URL + getDetailRiwayatPesertaRpl ,
        {
            params : data,
            headers: authHeader()
        });
    }

    getRiwayatPesertaSertifikasi(currentPage,pageSize,filter,idLevel) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            idLevel : idLevel
        };
        
        return axios.get(
            API_URL + getRiwayatPesertaSertifikasi ,
        {
            params : data,
            headers: authHeader()
        });
   
    }

    getRiwayatPesertaRpl(currentPage,pageSize,filter,idLevel) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            idLevel : idLevel
        };
        
        return axios.get(
            API_URL + getRiwayatPesertaRpl ,
        {
            params : data,
            headers: authHeader()
        });
   
    }
    

    postRiwayatPesertaRpl(formData) {        
        return axios
        .post(
            API_URL + postRiwayatPesertaRplUrl,
            formData,
            { headers: authHeader() }
        );
    }
  
}

export default new RiwayatPesertaService();
